import { ArrecadacaoFiltro } from "features/arrecadacoes/typings";
import { BaseFiltroPaginate } from "core/resources/enums/paginate";
import { useCallback, useState } from "react";

function useFiltroArrecadacao() {
  const [filtro, setFiltro] = useState<ArrecadacaoFiltro>({
    page: 1,
    limit: BaseFiltroPaginate.Limit,
  });

  const onChangeFiltro = useCallback(
    (newValues: Partial<ArrecadacaoFiltro>) => {
      setFiltro((prev: any) => ({ ...prev, ...newValues }));
    },
    []
  );

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
  };
}

export default useFiltroArrecadacao;
